import { render, staticRenderFns } from "./CplusYoutubeMonetizeConsentForm.vue?vue&type=template&id=2aa313b5&scoped=true&"
import script from "./CplusYoutubeMonetizeConsentForm.vue?vue&type=script&lang=js&"
export * from "./CplusYoutubeMonetizeConsentForm.vue?vue&type=script&lang=js&"
import style0 from "./CplusYoutubeMonetizeConsentForm.vue?vue&type=style&index=0&id=2aa313b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa313b5",
  null
  
)

export default component.exports